const { useEffect, useRef, useState } = require('react');
const { context } = require('app-context');
const { useAppSelector } = require('utils/redux');
const { previewViewer } = require('./useNerpy');
const SelectField = require('hooks/useFormPrimitives/ControlledSelectField');
const { default: Styled } = require('styled-components');

const internals = {};

module.exports = function NerpyPreferences() {

    const user = useAppSelector(context.selectors.all.getCurrentUserObject);
    const schoolId = useAppSelector(context.selectors.all.getCurrentSchoolId);
    const { Controls } = internals;
    if (!previewViewer(user, schoolId)) {
        return null;
    }

    return <Controls key={`${schoolId}:${user.roleId}:${user.id}`} />;
};

internals.Controls = function Controls() {

    const [preferences, setPreferences] = useState(null);
    const [name, setName] = useState('Nerpy');
    const [saving, setSaving] = useState(false);
    const [status, setStatus] = useState('');
    const active = useRef(true);
    const section = useRef(null);
    const inFlight = useRef(false);
    const { Section } = internals;
    useEffect(() => {

        active.current = true;
        context.api.nearpeer.nerpy.preferences().then((value) => {

            if (active.current) {
                setName(value.name || 'Nerpy');
                setPreferences({ mode: value.mode, notificationsEnabled: value.notificationsEnabled });
            }
        }).catch(() => {});
        return () => { active.current = false; };
    }, []);

    useEffect(() => {

        if (preferences && window.location.hash === '#nerpy') {
            section.current?.scrollIntoView?.({ block: 'start' });
        }
    }, [!!preferences]);

    if (!preferences) {
        return null;
    }

    const save = async (next) => {

        if (inFlight.current) {
            return;
        }

        inFlight.current = true;
        setSaving(true);
        setStatus('Saving…');
        try {
            const saved = await context.api.nearpeer.nerpy.savePreferences(next);
            if (active.current) {
                setPreferences({ mode: saved.mode, notificationsEnabled: saved.notificationsEnabled });
                setStatus(`${name} preferences saved.`);
                window.dispatchEvent(new Event('nerpy-preferences-changed'));
                context.redux.hooks.dispatch(context.actions.dataFetching.fetchNotifications());
            }
        }
        catch {
            if (active.current) {
                setStatus(`Your ${name} preferences could not be saved. Please try again.`);
            }
        }
        finally {
            if (active.current) {
                inFlight.current = false;
                setSaving(false);
            }
        }
    };

    return <Section ref={section} id='nerpy' aria-label={`${name} preferences`}>
        <h3>{name} — your companion</h3>
        <SelectField id='nerpy-mode' label={`How would you like to use ${name}?`} value={preferences.mode}
            options={[{ value: 'proactive', label: `Chats and all messages from ${name}` }, { value: 'manual', label: `Only when I open ${name}` }, { value: 'off', label: `Hide ${name} and stop messages` }]}
            textFieldProps={{ disabled: saving, variant: 'filled' }} onChange={(mode) => save({ mode, notificationsEnabled: mode === 'proactive' })} />
        <p role='status'>{status}</p>
    </Section>;
};

internals.Section = Styled.section`width: 100%; margin-top: 14px; scroll-margin-top: 80px; h3 { margin-bottom: 0; } p { margin: 8px 0; }`;
